import { useEffect, useState, useRef } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import { usePostItemListMutation } from '../../../../store/api/picklist'
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import { usePostMappedPicklistMutation, usePostCreatePicklistMutation, useGetPicklistDetailsQuery, useLazyGetPicklistDetailsQuery, usePostUpdatePickListMutation, usePostSubmitPickListMutation, usePostActiveSerialNosMutation } from '../../../../store/api/picklist'
import { useCreateDeliveryNotePicklistMutation } from '../../../../store/api/deliveryNoteApi'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import PrintModal from "../../../../../src/Core/Print/PrintModal";
import Attachment from '../../../../utils/Attachment'



function Pick({ pick_id }) {

    const nvg = useNavigate()
    const scanItemRef = useRef(null);
    const [tab, settab] = useState(1)
    const [result, setResult] = useState(false)
    const [tabdata, setTabdata] = useState({})
    const [getitem_list_data] = usePostItemListMutation()
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [itemList, setItemList] = useState([]);
    console.log(itemList, "itemList");
    const [fulldata, setfulldata] = useState();
    const [item_Rows, setitem_Rows] = useState([]);
    const [postMappedPicklist] = usePostMappedPicklistMutation();
    const [scannedBin, setScannedBin] = useState('');
    const [scannedItem, setScannedItem] = useState('');
    const [scanboll, setscanboll] = useState(false);
    const [picklist_id, setpicklist_id] = useState();
    const [submit, setsubmit] = useState(false);
    const [update, setupdate] = useState(false);
    const [selectRow, setselectRow] = useState("");
    const [activityboll, setactivityboll] = useState(false)
    const [pl_status, setpl_status] = useState('');
    const [showPrintModal, setShowPrintModal] = useState(false);
    console.log(fulldata?.message?.pick_status_st, "fulldata_main");
    const [scannedserialNo, setscannedserialNo] = useState([]);

    const [trigger, { data, error: error2, isFetching: isFetching2 }] = useLazyGetPicklistDetailsQuery();

    useEffect(() => {
        if (pick_id) {
            console.log("calling trigger on load...");
            trigger({ doctype: 'Pick List', name: pick_id });
        }
    }, [pick_id]);


    const [postActiveSerialNos] = usePostActiveSerialNosMutation();

    const fetchActiveSerialNos = async (payload) => {
        try {
            const response = await postActiveSerialNos(payload).unwrap();
            return response?.message?.message?.[0]?.serial_no || [];
        } catch (error) {
            console.error("Error fetching serial numbers:", error);
            return [];
        }
    };
    useEffect(() => {
        const enhanceItemsWithSerials = async () => {
            if (data?.message?.locations) {
                console.log("use_call");

                const updatedItems = await Promise.all(
                    data.message.locations.map(async (item) => {
                        const Scanned_Sno = item.Scanned_Sno
                            ? item.Scanned_Sno
                            : item.serial_no
                                ? item.serial_no.split(/[\n\\]+/)
                                : [];

                        let Sno = [];

                        if (
                            item.batch_no &&
                            item.picked_qty < item.order_qty
                        ) {
                            const payload = {
                                item_code: item.item_code,
                                warehouse: item.warehouse,
                                batch_no: item.batch_no,
                            };

                            const activeSerials = await fetchActiveSerialNos(payload);

                            Sno = activeSerials.filter(
                                (serial) => !Scanned_Sno.includes(serial)
                            );
                        }

                        return {
                            ...item,
                            Sno,
                            Scanned_Sno,
                        };
                    })
                );

                setfulldata(data);
                setItemList(updatedItems);
                setOriginalItems(updatedItems);
                setitem_Rows(updatedItems);
                setscanboll(true);
                setpicklist_id(pick_id);
                const status = data.message.status;
                setpl_status(status === "Draft" ? "" : status);
            }
        };

        enhanceItemsWithSerials();
    }, [data, pick_id]);


    const [newPageNumber, setnewPageNumber] = useState(1);
    const [originalItems, setOriginalItems] = useState([]);
    const handleBinScan = (e) => {
        scanItemRef.current?.focus();
        e.preventDefault();
        if (scannedBin.trim()) {
            const filtered = originalItems.filter(item => item.warehouse === scannedBin.trim());
            setitem_Rows(filtered);
        } else {
            handleClearBinFilter();
        }
    };
    const handleClearBinFilter = () => {
        setScannedBin('');
        const updatedOriginalItems = originalItems.map(origItem => {
            const updated = item_Rows.find(
                updatedItem => updatedItem.item_code === origItem.item_code &&
                    updatedItem.batch_no === origItem.batch_no
            );
            if (updated) {
                return {
                    ...origItem,
                    picked_qty: updated.picked_qty,
                    Scanned_Sno: updated.Scanned_Sno,
                };
            }
            return origItem;
        });

        setitem_Rows(updatedOriginalItems);
        setOriginalItems(updatedOriginalItems)
    };


    const handleItemScan = (e) => {
        e.preventDefault();
        setScannedItem("");
        if (scannedItem.trim()) {
            let matchedItem = null;
            const serialItem = item_Rows.filter((item) => item.Sno?.includes(scannedItem));
            if (serialItem.length > 0) {
                const filtered = item_Rows.map((item) => {
                    if (item.batch_no === serialItem[0].batch_no) {
                        if (!(item.warehouse == scannedBin.trim())) {
                            setError(`Item needs to be in the same Warehouse`);
                            setShowError(true);
                            return item;
                        }
                        const currentPickedQty = parseInt(item.picked_qty || 0);
                        const totalQty = parseInt(item.order_qty || 0);

                        if (currentPickedQty >= totalQty) {
                            setError(`Picked quantity exceeds available quantity`);
                            setShowError(true);
                            return item;
                        }

                        if (scannedserialNo.includes(scannedItem)) {
                            setError(`Serial number ${scannedItem} already scanned`);
                            setShowError(true);
                            return item;
                        }
                        setscannedserialNo([...scannedserialNo, scannedItem]);
                        item.picked_qty = currentPickedQty + 1;
                        item.Scanned_Sno = [...item.Scanned_Sno, scannedItem];
                        matchedItem = { ...item };
                        setnewPageNumber(1)
                    }

                    return item;
                });

                if (matchedItem !== null) {

                    const updatedList = [
                        matchedItem,
                        ...filtered.filter((item) => item.batch_no !== matchedItem.batch_no),
                    ];

                    setitem_Rows(updatedList);
                    setselectRow(matchedItem);
                    setnewPageNumber(1)

                }
                return;

            }

            const filtered = item_Rows.map((item) => {
                if (!(item.warehouse == scannedBin.trim())) {
                    setError(`Item needs to be in the same Warehouse`);
                    setShowError(true);
                    return item;
                }

                if (item.item_code === scannedItem.trim()) {
                    const currentPickedQty = parseInt(item.picked_qty || 0);
                    const totalQty = parseInt(item.order_qty || 0);

                    if (currentPickedQty >= totalQty) {
                        setError(`Picked quantity exceeds available quantity`);
                        setShowError(true);
                        return item;
                    }

                    item.picked_qty = currentPickedQty + 1;
                    matchedItem = { ...item };
                }

                return item;
            });
            if (matchedItem !== null) {
                const updatedList = [
                    matchedItem,
                    ...filtered.filter((item) => item.item_code !== matchedItem.item_code),
                ];

                setitem_Rows(updatedList);
                setselectRow(matchedItem);
            }


        }
    };

    const totalPickedQty = item_Rows.reduce((total, item) => {
        return total + (Number(item.picked_qty) || 0);
    }, 0);


    const totalQty = item_Rows.reduce((total, item) => {
        return total + (item.order_qty || 0);
    }, 0);
    const totalaccepted = item_Rows.reduce((total, item) => {
        return total + (item.qty || 0);
    }, 0);





    const [postupdatePicklist, { isLoading, isSuccesstwo, isErrortwo }] = usePostUpdatePickListMutation();
    const handleClicksave = () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }

        const payload = {
            name: picklist_id,
            locations: item_Rows.map(item => ({
                name: item.name,
                item_code: item.item_code,
                warehouse: item.warehouse,
                picked_qty: item.picked_qty,
                qty: item.qty,
                serial_no: item.Scanned_Sno,
                batch_no: item.batch_no
            })),
        };
        postupdatePicklist(payload)
            .unwrap()
            .then(res => {
                console.log('Picklist updated:', res);
                setupdate(true)
                setError('Updated');
                setptype('Picklist updated');
                setShowError(true);
                setactivityboll(prev => !prev);
                trigger({ doctype: 'Pick List', name: pick_id });

            })
            .catch(err => {
                alert('Error creating picklist:', err)
                console.error('Error creating picklist:', err);
            });
    };



    const [postsubmitPicklist, { isLoadithree, isSuccessthree, isErrorthree }] = usePostSubmitPickListMutation();
    const handleClicksubmit = () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }
        const payload = {
            name: picklist_id,

        };
        postsubmitPicklist(payload)
            .unwrap()
            .then(res => {
                console.log('Picklist submited:', res);
                setsubmit(true)
                setError('Submited');
                setptype('Picklist submited');
                setShowError(true);
                setactivityboll(prev => !prev);

            })
            .catch(err => {
                console.error('Error creating picklist:', err);
            });
    };
    const handleDevlivaryPick = async () => {
        try {
            localStorage.removeItem("deliveryNoteId");
            nvg('/outbound/outbound-create-delivery-note', {
                state: { picklist_id: picklist_id, is_new: true }
            });
        } catch (error) {
            console.error('Failed to create pick:', error);
            alert('Error creating pick. Please try again.');
        }
    };

    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/pick/outboundpick')}>Pick List </p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        Edit Pick
                        <button
                            className={` ${submit
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {fulldata?.message?.status}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    {(submit || (fulldata?.message?.pick_status_st == null && fulldata?.message?.status == "Open")) && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleDevlivaryPick}
                            disabled={isLoading}
                        >
                            Create Delivery Note
                        </Button>
                    )}



                    <Button
                        style={{ gap: '2px' }}
                        className="custom-btn-bluecolor"
                        iconName="BiCloudUpload"
                        iconSize={14}
                    >
                        Upload
                    </Button>

                    {/* <Button
                        style={{ gap: '2px' }}
                        className="createbtn"
                        iconName="GrCopy"
                        iconSize={12}
                    >
                        Duplicate
                    </Button> */}
                    {!pl_status && !submit && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={() => {
                                if (scanboll) {
                                    handleClicksave();
                                }
                            }}
                            disabled={isLoading}
                        >
                            {scanboll ? 'Update' : 'Update'}
                        </Button>
                    )}

                    {!pl_status && !submit && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleClicksubmit}
                            disabled={isLoading}
                        >
                            Submit
                        </Button>
                    )}
                    <p className="p-0 m-0">
                        <img src={printerimg}
                            onClick={() => setShowPrintModal(true)}
                            className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
                    </p>
                </div>
            </div>
            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        <Attachment doctype="Pick List" docname={pick_id} />
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 fulldata={fulldata} activityboll={activityboll} picklist_id={picklist_id} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            {/* Left Side Text Info */}
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <p className="NoOfLine">
                                    No. of lines - <span style={{ color: '#2563EB' }}>{item_Rows.length}</span>
                                </p>
                                <p className="TotalQty">
                                    Total Quantity - <span style={{ color: '#16A34A' }}>{totalaccepted > 0 ? totalaccepted : totalQty}</span>
                                </p>
                                <p className="ReceivedQty">
                                    Scanned Quantity - <span style={{ color: '#EC642A' }}>{totalPickedQty}</span>
                                </p>
                            </div>
                            {scanboll &&
                                <div className="d-flex mx-2" style={{ gap: '10px', borderColor: 'rgba(0,0,0,0.2)' }}>
                                    <form onSubmit={handleBinScan}>
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                name="binScan"
                                                placeholder="Scan Bin"
                                                className="form-control pe-4"
                                                value={scannedBin}
                                                onChange={(e) => setScannedBin(e.target.value)}
                                                style={{
                                                    width: '227px',
                                                    border: '1px solid #333',
                                                    fontSize: '12.8px'
                                                }}
                                            />
                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    color: "#EC642A",
                                                    fontSize: '12.8px'
                                                }}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>
                                    </form>



                                    <form onSubmit={handleItemScan}>
                                        <div className="position-relative" style={{ width: '227px' }}>
                                            <div
                                                style={{ position: 'relative' }}
                                                title={!scannedBin ? 'Scan Bin' : ''}
                                            >
                                                <input
                                                    ref={scanItemRef}
                                                    type="text"
                                                    placeholder="Scan Item"
                                                    className="form-control pe-4"
                                                    value={scannedItem}
                                                    onChange={(e) => setScannedItem(e.target.value)}
                                                    disabled={!scannedBin}
                                                    style={{
                                                        width: '100%',
                                                        border: '1px solid #333',
                                                        backgroundColor: !scannedBin ? '#f1f1f1' : 'white',
                                                        cursor: !scannedBin ? 'not-allowed' : 'text',
                                                        fontSize: '12.8px'
                                                    }}
                                                />

                                                {!scannedBin && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            right: '40px',
                                                            transform: 'translateY(-50%)',
                                                            pointerEvents: 'none',
                                                            color: '#999',
                                                        }}
                                                    >
                                                        <GetIcon iconName="MdBlock" size={16} />
                                                    </div>
                                                )}
                                            </div>

                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                disabled={!scannedBin}
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: !scannedBin ? 'not-allowed' : 'pointer',
                                                    color: "#EC642A",
                                                }}
                                                title={!scannedBin ? 'Scan Bin' : 'Submit'}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>

                                    </form>
                                </div>}

                        </div>

                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table pageNo={{ newPageNumber, setnewPageNumber }} list_data={itemList} fulldata={fulldata} row={{ Rows: item_Rows, setRows: setitem_Rows, selectRow }} scanboll={scanboll} submit={submit} />
                    </div>
                </div>
                {showPrintModal && (
                    <PrintModal
                        onClose={() => setShowPrintModal(false)}
                        documentId={pick_id}
                        doctype="Pick List"
                        title="Print GRN"
                    />
                )}

                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </div>
        </>
    )
}

export default Pick



